var owl = $(".owl-carousel.logo_slider");
owl.owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 4000,
  margin: 30,
  nav: true,
  slideBy:1,
  responsive: {
    0: {
      items: 1,
    },
    768:{
      items: 2,
    },
    1000: {
      items: 6,
    },
    1440: {
      items: 8,
    },
  }
});
         
// owl.owlCarousel();
// Go to the next item
$(".forward").click(function (e) {
  e.stopPropagation();
  owl.trigger("next.owl.carousel");
});
// Go to the previous item
$(".back").click(function (e) {
  e.stopPropagation();
  owl.trigger("prev.owl.carousel");
});